// extracted by mini-css-extract-plugin
export default {"feedbackMessagesWrapper":"FeedbackMessages_feedbackMessagesWrapper__CxCUP","feedbackToast":"FeedbackMessages_feedbackToast__VZ3HS"};